import dayjs from "dayjs";

// Returns dates as ISO strings "YYYY-MM-DDTHH:mm:ss" — same format as datepicker
export const getDatesByOption = (value) => {
  const today = dayjs().startOf("day");

  switch (value) {
    case "today":
      return {
        from: today.format("YYYY-MM-DDTHH:mm:ss"),
        to: today.endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
      };

    case "yesterday": {
      const y = today.subtract(1, "day");
      return {
        from: y.startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        to: y.endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
      };
    }

    case "last_month":
      return {
        from: today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DDTHH:mm:ss"),
        to: today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DDTHH:mm:ss"),
      };

    case "current_month":
      return {
        from: today.startOf("month").format("YYYY-MM-DDTHH:mm:ss"),
        to: today.format("YYYY-MM-DDTHH:mm:ss"),
      };
    case "year_thru_last_month":
      return {
        from: today.startOf("year").format("YYYY-MM-DDTHH:mm:ss"),
        to: today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DDTHH:mm:ss"),
      };

    case "current_year":
      return {
        from: today.startOf("year").format("YYYY-MM-DDTHH:mm:ss"),
        to: today.endOf("year").format("YYYY-MM-DDTHH:mm:ss"),
      };
    case "current_year_to_end":
      return {
        from: today.startOf("year").format("YYYY-MM-DDTHH:mm:ss"),
        to: today.endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
      };

    default:
      return null;
  }
};
// const getDatesByOption = (value) => {
//   const today = dayjs().startOf("day");
//   switch (value) {
//     case "today":
//       return { from: today.toDate(), to: today.endOf("day").toDate() };
//     case "yesterday": {
//       const y = today.subtract(1, "day");
//       return { from: y.toDate(), to: y.endOf("day").toDate() };
//     }
//     case "last_month":
//       return {
//         from: today.subtract(1, "month").startOf("month").toDate(),
//         to: today.subtract(1, "month").endOf("month").toDate(),
//       };
//     case "current_month":
//       return { from: today.startOf("month").toDate(), to: today.toDate() };
//     case "year_thru_last_month":
//       return {
//         from: today.startOf("year").toDate(),
//         to: today.subtract(1, "month").endOf("month").toDate(),
//       };
//     case "current_year":
//       return {
//         from: today.startOf("year").toDate(),
//         to: today.endOf("year").toDate(),
//       };
//     default:
//       return null;
//   }
// };
